const description = {
    'frontdoor': 'Hive contrôle la porte d\'entrée'
}

export default description
